import blackPin from '@/assets/images/maps/pin-black.svg'
import redPin from '@/assets/images/maps/pin-red.svg'
import dinoPin from '@/assets/images/maps/pin-dino.svg'
import bricomarchePin from '@/assets/images/maps/pin-bricomarche.svg'
import intermarchePin from '@/assets/images/maps/pin-intermarche.svg'
import lidlPin from '@/assets/images/maps/pin-lidl.svg'
import tescoPin from '@/assets/images/maps/pin-tesco.svg'
import polomarketPin from '@/assets/images/maps/pin-polomarket.svg'
import stokrotkaPin from '@/assets/images/maps/pin-stokrotka.svg'

export const icons = [
    {
        codeName: 'LIDL',
        name: 'Lidl',
        src: lidlPin
    },
    {
        codeName: 'DINO',
        name: 'Dino',
        src: dinoPin
    },
    {
        codeName: 'IMR',
        name: 'Intermarche',
        src: intermarchePin
    },
    {
        codeName: 'AMS-IMR',
        name: 'AMS-Intermarche',
        src: intermarchePin
    },
    {
        codeName: 'BRM',
        name: 'Bricomarche',
        src: bricomarchePin
    },
    {
        codeName: 'AMS-BRM',
        name: 'AMS-Bricomarche',
        src: bricomarchePin
    },
    {
        codeName: 'PMR',
        name: 'PoloMarket',
        src: polomarketPin
    },
    {
        codeName: 'TSC',
        name: 'Tesco',
        src: tescoPin
    },
    {
        codeName: 'STK',
        name: 'Stokrotka',
        src: stokrotkaPin
    },
    {
        codeName: 'black',
        name: 'Siedziba ekipy',
        src: blackPin,
    },
    {
        codeName: 'default',
        name: 'Inne',
        src: redPin
    },
]

export function googleMapsApiLoader(params) {
    if (window.google) {
        return Promise.resolve(window.google)
    }

    return new Promise((resolve, reject) => {
        loadAutoCompleteAPI(params)

        window.initMap = () => {
            resolve(window.google)
        }

        setTimeout(() => {
            if (!window.google) {
                reject(new Error('Loading took too long'))
            }
        }, 5000)
    })
}

function loadAutoCompleteAPI(params) {
    const script = document.createElement('script')

    script.type = 'text/javascript'

    script.src = urlBuilder({
        base: 'https://maps.googleapis.com/maps/api/js',
        libraries: params.libraries || [],
        apiKey: params.apiKey,
        mapId: params.mapId,
        client: params.client,
        language: params.language,
        version: params.version,
        callback: 'initMap'
    })

    document.querySelector('head').appendChild(script)
}

function urlBuilder(params) {
    let builtUrl = params.base

    builtUrl += '?'

    if (params.apiKey) builtUrl += 'key=' + params.apiKey + '&'
    if (params.mapId) builtUrl += 'map_ids=' + params.mapId + '&'
    if (params.client) builtUrl += 'client=' + params.client + '&'
    if (params.language) builtUrl += 'language=' + params.language + '&'
    if (params.version) builtUrl += 'v=' + params.version + '&'

    if (params.libraries.length > 0) {
        builtUrl += 'libraries='

        params.libraries.forEach((library, index) => {
            builtUrl += library

            if (index !== params.libraries.length - 1) {
                builtUrl += ','
            }
        })

        builtUrl += '&'
    }

    builtUrl += 'callback=' + params.callback

    return builtUrl
}
